import api from './api';
import { DireccionCliente } from '../interfaces/DireccionCliente';

const direccionClienteService = {
  // Obtener todas las direcciones de un cliente (retorna array directamente)
  getDirecciones: async (nroCliente: number): Promise<DireccionCliente[]> => {
    const response = await api.get<DireccionCliente[]>(`/api/Clientes/${nroCliente}/Direcciones`);
    return response.data;
  },

  // Obtener una dirección específica
  getDireccion: async (nroCliente: number, codigoDireccion: string): Promise<DireccionCliente> => {
    const response = await api.get<DireccionCliente>(`/api/Clientes/${nroCliente}/Direcciones/${codigoDireccion}`);
    return response.data;
  },

  // Crear una nueva dirección
  createDireccion: async (nroCliente: number, direccion: DireccionCliente): Promise<DireccionCliente> => {
    const response = await api.post<DireccionCliente>(`/api/Clientes/${nroCliente}/Direcciones`, direccion);
    return response.data;
  },

  // Actualizar una dirección
  updateDireccion: async (nroCliente: number, codigoDireccion: string, direccion: Partial<DireccionCliente>): Promise<void> => {
    await api.put(`/api/Clientes/${nroCliente}/Direcciones/${codigoDireccion}`, direccion);
  },

  // Eliminar una dirección
  deleteDireccion: async (nroCliente: number, codigoDireccion: string): Promise<void> => {
    await api.delete(`/api/Clientes/${nroCliente}/Direcciones/${codigoDireccion}`);
  }
};

export default direccionClienteService;

